<template>
	<div ref="" style="border:0px solid red;">
		<div class="InfoTABPan">
			<div class="InfoTAB2" style="margin-left:20px;" @click="onCompInfoClick">{{getLangText("企业")}}</div>
			<div class="InfoTAB2_A" style="margin-left:10px;">{{getLangText("账号")}}</div>
			<div class="InfoTAB2" style="margin-left:10px;" v-if="custAiFlag" @click="onAIInfoClick">{{getLangText("AI接口")}}</div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('账号')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="userAcct" disabled=true>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; margin-top:10px; float:left;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('姓名')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="userName">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<check style="height:30px; margin-right:10px; margin-left:30px;" :size="18" :grpName="'GrpPswd'" :val="1" :capt="getLangText('修改密码')" v-model="PWDFlag" :checked="false"></check>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;" v-if="PWDFlag==1">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('原密码')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="oldPwd">
		</div>
		<div class="SiftPanel" style="border:0px solid #bbbbbb;" v-if="PWDFlag==1">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('新密码')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="newPwd1">
		</div>
		<div class="SiftPanel" style="border:0px solid #bbbbbb;" v-if="PWDFlag==1">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('确认新密码')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="newPwd2">
		</div>

		<div style="float:left; width:400px; height:40px; border:0px solid red; margin-top:20px;">
			<div class="NButton DIVNoSelect" style="width:120px; height:36px; float:left; margin-left:140px;" @click="onSaveClick">{{getLangText("保存")}}</div>
		</div>

	</div>
</template>

<script>

import check      from '../cf/cck'

export default {
	name: 'acctInfo',
	components:{
		check
	},
	data () {
		return {
			PWDFlag: "",
			oldPwd: "",
			newPwd1: "",
			newPwd2: "",
			userName: "",
			userAcct: "",
			custAiFlag: this.login.custAiFlag
		}
	},
	mounted: function(){
		this.userName = this.login.userName;
		this.userAcct = this.login.userAcct;
	},
	computed:{

	},
	methods:{
		onCompInfoClick: function(){
			this.$router.push( "/FrameBody/compInfo" );
		},
		onAIInfoClick: function(){
			this.$router.push( "/FrameBody/aiInfo" );
		},
		onSaveClick: function(){
			let body={ userName: this.userName };
			if( this.PWDFlag == 1 )
			{
				if( this.newPwd1 != this.newPwd2 )
				{
					this.appRoot.app.showDlgCfm( this.DialogType.Err, LangText("错误"), LangText("两次输入密码不一致"), "", null );
					return;
				}
				if( this.newPwd1.length < 6 )
				{
					this.appRoot.app.showDlgCfm( this.DialogType.Err, LangText("错误"), LangText("密码长度不足"), "", null );
					return;
				}

				body.userOldPswd = this.oldPwd;
				body.userNewPswd = this.newPwd1;
			}
			this.doTrade( "POST", ServAddr+"/api/user/userEdit", this.userEditOK, true, body, null );
		},
		userEditOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 2000, this.getErrorText(data.code), this.CLR.Err );
				return;
			}
			this.login.userName = this.userName;
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// acctInfo.vue?72be9057